import { useContext } from "react";
import ReactPlayer from "react-player/lazy";
import { AppContext } from "../contexts/AppContext";
import VideoEmbed from "./VideoEmbed";

const VideoPlayer = ({
  videoSrc,
  id,
  wrapper = { width: "640px", height: "360px" },
  playListener = () => null,
  stopListener = () => null,
}) => {
  const appContext = useContext(AppContext);
  return (
    // <ReactPlayer
    //   width={wrapper.width}
    //   height={wrapper.height}
    //   url={videoSrc}
    //   className
    //   controls
    //   onPlay={playListener}
    //   onPause={stopListener}
    //   onEnded={stopListener}
    //   playing={appContext.currentPlayerId === id}
    // />
    <VideoEmbed videoLink={videoSrc} />
  );
};

export default VideoPlayer;
